/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.191.0-v202609092247-CDH
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqJobsApiClass {
 
   constructor() {}

  /**
   * @summary Create a job to capture a content screenshot at a regular interval
  */
  public createContentJob(
    body: string,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/jobs/content`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.JobOutputV1>;
  }

  /**
   * @summary Create a job to update a date range and its content at a regular interval
  */
  public createDateRangeJob(
    body: string,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/jobs/dateRange`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.JobOutputV1>;
  }

  /**
   * @summary Delete a scheduled job and cancel any currently running instance
   * @param {string} group - Group to which the job belongs
   * @param {string} id - ID of the job to delete
   * @param {string} [schedulerType=User] - Which scheduler to query for the job. The options are User (default), System, and AsyncMigration.
  */
  public deleteJob(
    {
      group,
      id,
      schedulerType
    } : {
      group: string,
      id: string,
      schedulerType?: DeleteJobSchedulerTypeEnum
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (group === null || group === undefined) {
      throw new Error("'group' parameter required");
    }

    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/jobs/${encodeURIComponent(String(group))}/${encodeURIComponent(String(id))}`
      .replace('{group}', encodeURIComponent(String(group)))
      .replace('{id}', encodeURIComponent(String(id)));

    const queryParams = {
      ['schedulerType']: schedulerType
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'delete',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Get details of a specified job
   * @param {string} group - Group to which the job belongs
   * @param {string} id - ID of the job to retrieve
   * @param {string} [schedulerType=User] - Which scheduler to query for the job. The options are User (default), System, and AsyncMigration.
  */
  public getJob(
    {
      group,
      id,
      schedulerType
    } : {
      group: string,
      id: string,
      schedulerType?: GetJobSchedulerTypeEnum
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (group === null || group === undefined) {
      throw new Error("'group' parameter required");
    }

    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/jobs/${encodeURIComponent(String(group))}/${encodeURIComponent(String(id))}`
      .replace('{group}', encodeURIComponent(String(group)))
      .replace('{id}', encodeURIComponent(String(id)));

    const queryParams = {
      ['schedulerType']: schedulerType
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.JobOutputV1>;
  }

  /**
   * @summary Get a paginated list of run histories across all job types, with optional filtering and sorting. Only administrators may perform this action. This endpoint is experimental and may change in future releases.
   * @param {Array<string>} [jobTypes] - Optionally narrow the runs to these job types (matches any), as a repeated query parameter. Omit for all types.
   * @param {Array<string>} [containerItemIds] - Optionally narrow the runs to those whose containing item is in this list of IDs (matches any). Omit to return runs for any item.
   * @param {number} [offset=0] - The pagination offset, the index of the first run returned in this page
   * @param {number} [limit=40] - The pagination limit, the maximum number of runs returned in this page (at most 1000)
   * @param {boolean} [inProgressOnly=false] - When true, return only runs that are still in progress (no completion recorded yet)
   * @param {string} [startedAfter] - Only runs that started at or after this ISO-8601 timestamp
   * @param {string} [startedBefore] - Only runs that started at or before this ISO-8601 timestamp
   * @param {string} [completedAfter] - Only runs that completed at or after this ISO-8601 timestamp
   * @param {string} [completedBefore] - Only runs that completed at or before this ISO-8601 timestamp
   * @param {boolean} [errorFilter] - Filter on whether a run recorded an internal run-level error message. The raw message is not exposed.
   * @param {boolean} [success] - Filter on the run-level outcome: only runs that succeeded (true) or failed (false). In-progress runs have no outcome yet and are excluded by either value
   * @param {string} [triggeredByUserId] - Only runs triggered by this user (GUID)
   * @param {number} [minDurationSeconds] - Only completed runs whose duration (completed - started) exceeds this many seconds
   * @param {string} [orderBy=StartedAt] - Field to order by: StartedAt, CompletedAt, or Duration
   * @param {boolean} [sortAsc=false] - Sort ascending when true, descending when false (the default, so the newest runs come first). When ordering by CompletedAt or Duration, in-progress runs have no value yet and always sort last.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getJobRuns(
    {
      jobTypes,
      containerItemIds,
      offset,
      limit,
      inProgressOnly,
      startedAfter,
      startedBefore,
      completedAfter,
      completedBefore,
      errorFilter,
      success,
      triggeredByUserId,
      minDurationSeconds,
      orderBy,
      sortAsc
    } : {
      jobTypes?: GetJobRunsJobTypesEnum[],
      containerItemIds?: Array<string>,
      offset?: number,
      limit?: number,
      inProgressOnly?: boolean,
      startedAfter?: string,
      startedBefore?: string,
      completedAfter?: string,
      completedBefore?: string,
      errorFilter?: boolean,
      success?: boolean,
      triggeredByUserId?: string,
      minDurationSeconds?: number,
      orderBy?: GetJobRunsOrderByEnum,
      sortAsc?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/jobs/runs`;

    const queryParams = {
      ['jobTypes']: jobTypes,      ['containerItemIds']: containerItemIds,      ['offset']: offset,      ['limit']: limit,      ['inProgressOnly']: inProgressOnly,      ['startedAfter']: startedAfter,      ['startedBefore']: startedBefore,      ['completedAfter']: completedAfter,      ['completedBefore']: completedBefore,      ['errorFilter']: errorFilter,      ['success']: success,      ['triggeredByUserId']: triggeredByUserId,      ['minDurationSeconds']: minDurationSeconds,      ['orderBy']: orderBy,      ['sortAsc']: sortAsc
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.JobRunOutputListV1>;
  }

  /**
   * @summary List of scheduled jobs
   * @param {number} [offset=0] - The pagination offset, the index of the first job that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of jobs that will be returned in this page of results
   * @param {string} [schedulerType=User] - Which scheduler to query for jobs. The options are User (default), System, and AsyncMigration.
  */
  public getJobs(
    {
      offset,
      limit,
      schedulerType
    } : {
      offset?: number,
      limit?: number,
      schedulerType?: GetJobsSchedulerTypeEnum
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/jobs`;

    const queryParams = {
      ['offset']: offset,      ['limit']: limit,      ['schedulerType']: schedulerType
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.GetJobsOutputV1>;
  }

  /**
   * @summary A simplified endpoint for fetching a screenshot of Seeq content at a regular interval.
   * @param {string} id - The content id to capture
  */
  public getScreenshotFromContent(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/jobs/content/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<models.ScreenshotOutputV1>;
  }

  /**
   * @summary Validate a list of Quartz cron expressions
  */
  public validateCron(
    body: models.ValidateCronListInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/jobs/validateCron`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ValidateCronListOutputV1>;
  }

}

export const DeleteJobSchedulerTypeEnum = {
    User: 'User',
    System: 'System',
    AsyncMigration: 'AsyncMigration'
} as const;

export type DeleteJobSchedulerTypeEnum = typeof DeleteJobSchedulerTypeEnum[keyof typeof DeleteJobSchedulerTypeEnum];
export const GetJobSchedulerTypeEnum = {
    User: 'User',
    System: 'System',
    AsyncMigration: 'AsyncMigration'
} as const;

export type GetJobSchedulerTypeEnum = typeof GetJobSchedulerTypeEnum[keyof typeof GetJobSchedulerTypeEnum];
export const GetJobRunsJobTypesEnum = {
    CONDITIONMONITOR: 'CONDITION_MONITOR',
    SIGNALMONITOR: 'SIGNAL_MONITOR',
    ITEMFINDER: 'ITEM_FINDER',
    REPORT: 'REPORT',
    DATERANGE: 'DATE_RANGE',
    CONTENT: 'CONTENT'
} as const;

export type GetJobRunsJobTypesEnum = typeof GetJobRunsJobTypesEnum[keyof typeof GetJobRunsJobTypesEnum];
export const GetJobRunsOrderByEnum = {
    StartedAt: 'StartedAt',
    CompletedAt: 'CompletedAt',
    Duration: 'Duration'
} as const;

export type GetJobRunsOrderByEnum = typeof GetJobRunsOrderByEnum[keyof typeof GetJobRunsOrderByEnum];
export const GetJobsSchedulerTypeEnum = {
    User: 'User',
    System: 'System',
    AsyncMigration: 'AsyncMigration'
} as const;

export type GetJobsSchedulerTypeEnum = typeof GetJobsSchedulerTypeEnum[keyof typeof GetJobsSchedulerTypeEnum];

export const sqJobsApi = new sqJobsApiClass();

export type sqJobsApiEndpoints = {
  'createContentJob': {
    method: 'post';
    path: '/jobs/content';
    response: models.JobOutputV1;
  };
  'createDateRangeJob': {
    method: 'post';
    path: '/jobs/dateRange';
    response: models.JobOutputV1;
  };
  'deleteJob': {
    method: 'delete';
    path: '/jobs/${encodeURIComponent(String(group))}/${encodeURIComponent(String(id))}';
    response: models.StatusMessageBase;
  };
  'getJob': {
    method: 'get';
    path: '/jobs/${encodeURIComponent(String(group))}/${encodeURIComponent(String(id))}';
    response: models.JobOutputV1;
  };
  'getJobRuns': {
    method: 'get';
    path: '/jobs/runs';
    response: models.JobRunOutputListV1;
  };
  'getJobs': {
    method: 'get';
    path: '/jobs';
    response: models.GetJobsOutputV1;
  };
  'getScreenshotFromContent': {
    method: 'get';
    path: '/jobs/content/${encodeURIComponent(String(id))}';
    response: models.ScreenshotOutputV1;
  };
  'validateCron': {
    method: 'post';
    path: '/jobs/validateCron';
    response: models.ValidateCronListOutputV1;
  };
};

type ApiCreateContentJobResponse = models.JobOutputV1;
type ApicreateContentJobMutationParams = Parameters<typeof sqJobsApi.createContentJob> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqJobsApi.createContentJob>;
type ApicreateContentJobMutationVariables = string;

export function useApiCreateContentJobMutation(
  options?: Omit<UseMutationOptions<ApiCreateContentJobResponse, AxiosError<SeeqErrorData>,
    ApicreateContentJobMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateContentJobResponse, AxiosError<SeeqErrorData>,
  ApicreateContentJobMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApicreateContentJobMutationVariables) =>
      sqJobsApi.createContentJob(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiCreateDateRangeJobResponse = models.JobOutputV1;
type ApicreateDateRangeJobMutationParams = Parameters<typeof sqJobsApi.createDateRangeJob> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqJobsApi.createDateRangeJob>;
type ApicreateDateRangeJobMutationVariables = string;

export function useApiCreateDateRangeJobMutation(
  options?: Omit<UseMutationOptions<ApiCreateDateRangeJobResponse, AxiosError<SeeqErrorData>,
    ApicreateDateRangeJobMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateDateRangeJobResponse, AxiosError<SeeqErrorData>,
  ApicreateDateRangeJobMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApicreateDateRangeJobMutationVariables) =>
      sqJobsApi.createDateRangeJob(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiDeleteJobResponse = models.StatusMessageBase;
type ApideleteJobMutationParams = Parameters<typeof sqJobsApi.deleteJob> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqJobsApi.deleteJob>;

export function useApiDeleteJobMutation(
  options?: Omit<UseMutationOptions<ApiDeleteJobResponse, AxiosError<SeeqErrorData>,
    ApideleteJobMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiDeleteJobResponse, AxiosError<SeeqErrorData>,
  ApideleteJobMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApideleteJobMutationParams) =>
      sqJobsApi.deleteJob(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiGetJobResponse = models.JobOutputV1;
export function GetJobQueryKey(
  params: Parameters<typeof sqJobsApi.getJob>[0],
) {
  return ['sqJobsApi', 'getJob', params] as const;
}

export function useApiGetJobQuery(
  params: Parameters<typeof sqJobsApi.getJob>[0],
  options?: Omit<UseQueryOptions<ApiGetJobResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetJobResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetJobQueryKey(params),
    queryFn: () =>
      sqJobsApi.getJob(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetJobRunsResponse = models.JobRunOutputListV1;
export function GetJobRunsQueryKey(
  params: Parameters<typeof sqJobsApi.getJobRuns>[0],
) {
  return ['sqJobsApi', 'getJobRuns', params] as const;
}

export function useApiGetJobRunsQuery(
  params: Parameters<typeof sqJobsApi.getJobRuns>[0],
  options?: Omit<UseQueryOptions<ApiGetJobRunsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetJobRunsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetJobRunsQueryKey(params),
    queryFn: () =>
      sqJobsApi.getJobRuns(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetJobsResponse = models.GetJobsOutputV1;
export function GetJobsQueryKey(
  params: Parameters<typeof sqJobsApi.getJobs>[0],
) {
  return ['sqJobsApi', 'getJobs', params] as const;
}

export function useApiGetJobsQuery(
  params: Parameters<typeof sqJobsApi.getJobs>[0],
  options?: Omit<UseQueryOptions<ApiGetJobsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetJobsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetJobsQueryKey(params),
    queryFn: () =>
      sqJobsApi.getJobs(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetScreenshotFromContentResponse = models.ScreenshotOutputV1;
export function GetScreenshotFromContentQueryKey(
  params: Parameters<typeof sqJobsApi.getScreenshotFromContent>[0],
) {
  return ['sqJobsApi', 'getScreenshotFromContent', params] as const;
}

export function useApiGetScreenshotFromContentQuery(
  params: Parameters<typeof sqJobsApi.getScreenshotFromContent>[0],
  options?: Omit<UseQueryOptions<ApiGetScreenshotFromContentResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetScreenshotFromContentResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetScreenshotFromContentQueryKey(params),
    queryFn: () =>
      sqJobsApi.getScreenshotFromContent(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiValidateCronResponse = models.ValidateCronListOutputV1;
type ApivalidateCronMutationParams = Parameters<typeof sqJobsApi.validateCron> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqJobsApi.validateCron>;
type ApivalidateCronMutationVariables = models.ValidateCronListInputV1;

export function useApiValidateCronMutation(
  options?: Omit<UseMutationOptions<ApiValidateCronResponse, AxiosError<SeeqErrorData>,
    ApivalidateCronMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiValidateCronResponse, AxiosError<SeeqErrorData>,
  ApivalidateCronMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApivalidateCronMutationVariables) =>
      sqJobsApi.validateCron(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
